import { ProjectReview } from "@/components/projects/project-review";
import { Navigate, createFileRoute, useLoaderData } from "@tanstack/react-router";

/**
 * `/projects/:slug/planner`: a conversation with Radim about this project, in
 * writing or by voice, and the record of what came out of each one.
 *
 * A manager surface, like Suggestions: Radim changes this project's tickets
 * under your name, so it takes the same right as editing the project. The tab
 * isn't offered to anyone else, and a typed-in URL bounces to the project.
 *
 * E2E behaviour contract: `e2e/projects/project-review.spec.ts`.
 */

export const Route = createFileRoute("/_app/projects/$slug/planner")({
  component: ProjectPlannerPage,
  validateSearch: (search: Record<string, unknown>): { review?: string } =>
    typeof search.review === "string" ? { review: search.review } : {},
});

function ProjectPlannerPage() {
  const { project, canEdit } = useLoaderData({ from: "/_app/projects/$slug" });
  const params = Route.useParams();
  const { review } = Route.useSearch();

  if (!canEdit) {
    return <Navigate to="/projects/$slug" params={{ slug: params.slug }} />;
  }

  return (
    <div className="w-full space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Planner</h1>
        <p className="text-muted-foreground mt-1">
          Plan {project.name} with Radim: ideas, new and reworked tickets, plans for Metoděj, or a
          walk through the open tickets. Just tell him what you want.
        </p>
      </div>

      <ProjectReview projectId={project.id} slug={params.slug} initialReviewId={review} />
    </div>
  );
}
